export default "__VITE_ASSET__vk4kXdUf__"